import Vue from 'vue';

export const userActivityService = {
  async retrieveUserActivityLog(limit, offset = null, sortOrder) {
    return Vue.axios
      .get(`/event-log/user-activity`, {
        params: {
          ...sortOrder,
          recordsPerPage: limit,
          offset
        }
      })
      .then(response => response.data);
  },

  async retrieveFilteredRecordCount(filterParams) {
    return Vue.axios
      .get(`/event-log/user-activity/count`, {
        params: {
          searchParam: filterParams
        }
      })
      .then(response => response.data);
  },

  async deleteuserActivityLog(params) {
    return Vue.axios
      .delete(`user-activity/delete`, {
        data: {
          ...params
        }
      })
      .then(response => response.data);
  }
};
